import "./MobileAppAside.scss";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import OnlineMenusIcon from "../icons/OnlineMenusIcon";
import MyBrandIcon from "../icons/MyBrandIcon";
import DisplayIconBlack from "../icons/DisplayIconBlack";
import LinkPagesIconBlack from "../icons/LinkPagesIconBlack";
import { env } from "../../env/env";
import LocationDropdown from "../LocationDropdown";
import { LocationDto, MemberDto, MemberDtoPlanEnum } from "../../generated/dashboard-client";
import React, { useContext, useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import {memberState} from "../../state/atoms";
import { ProStar } from "../account/misc/ProStar";
import SavedDesignsIcon from "../icons/SavedDesignsIcon";
import {
  SettingOutlined,
  CreditCardOutlined,
  DollarCircleOutlined,
  PrinterOutlined,
  QuestionCircleOutlined
} from "@ant-design/icons";
import ChangeLocationIcon from "../icons/ChangeLocationIcon";
import UserIcon from "../icons/UserIcon";
//import UploadIcon from "../icons/UploadIcon";
import { Button } from "antd";
import { OmInUseModal } from "../om/OmInUseModal";
import CartIcon from "../icons/CartIcon";
import {homePaths, isTestEnv} from "../../util/constants";
import OrdersApi from "../../api/OrdersApi";
import { AppContext } from "../../AppContext";
import PricingIcon from "../icons/PricingIcon";
import CompassIcon from "../icons/CompassIcon";
import MobileTemplatesDropdown from "./MobileTemplatesDropdown";
import MobileDigitalDropdown from "./MobileDigitalDropdown";
import { synchronousRequest } from "../../util/utils";

interface MobileAppAsideProps {
  activeLocation: LocationDto;
  closeDrawer: () => void;
  cartCount: number;
  setCartCount: any;
  users: MemberDto[];
}

enum AsideMode {
  Dashboard,
  Account,
  Hidden,
}

export default function MobileAppAside({
  activeLocation,
  closeDrawer,
  cartCount,
  setCartCount,
  users
}: MobileAppAsideProps) {
  const loc = useLocation();

  const { location } = useContext(AppContext);
  const member = useRecoilValue(memberState);
  const [mode, setMode] = useState(AsideMode.Dashboard);
  const [isOoLoading, setOoLoading] = useState(false);
  const [isOoInUse, setOoInUse] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (loc.pathname.indexOf("/account") > -1) {
      setMode(AsideMode.Account);
    } else {
      setMode(AsideMode.Dashboard);
    }
  }, [loc]);

  useEffect(() => {
    if (!member.oldLoginKey || !location || !location.internalId) return;

    if (env.debug) {
      OrdersApi.getDraftItemsCount(location.internalId!).then((resp) => {
        setCartCount(resp.data);
      });
    }
  }, [member, location, setCartCount])

  function onOnlineMenuClick() {
    if (member.plan === MemberDtoPlanEnum.Free) {
      navigate(`${env.dashboardPath}/online-menus/`);
      closeDrawer();
      return;
    }
    
    setOoLoading(true);
    closeDrawer();

    setTimeout(() => {
      const resp = synchronousRequest(`/app/online/location/stats/${activeLocation.internalId!}?oo=true`);
      let location: any | null = null;
      if (resp) {
        try {
          location = JSON.parse(JSON.parse(resp).data).location;
        } catch (e) {
          console.error(e);
        }
      }

      if (location?.inUse) {
        setOoInUse(true);
        setOoLoading(false);
      } else {
        const base = isTestEnv ? 'https://test.mhmfun.com' : 'https://ohbz.com';//window.location.href.indexOf("staging.") > -1 ? "https://www.musthavemenus.com" : env.basePath;
        const tkn = window.localStorage.getItem("tkn");
        window.open(`${base}${env.ooContextPath}?businessId=${activeLocation.internalId}&tkn=${tkn}`, '_blank');
        setOoLoading(false);
      }
    }, 200);
  }

  function bookDemoClick() {
    window.open('/feature/book-demo-auth.html', '_blank');
  }

  function goToDesignServices() {
    window.open("/feature/menu-services.html", "_blank");
  }


  return (
    <>
      {mode !== AsideMode.Hidden && (
        <div className={"aside-mobile"}>
          {mode === AsideMode.Dashboard && (
            <>
              {member.id && <LocationDropdown location={activeLocation} users={users} />}
              <nav>
                {member.id &&
                <ul>
                  <li>
                    <NavLink
                      to={`${env.dashboardPath}/designs/${activeLocation.internalId}`}
                      className={
                        homePaths.includes(window.location.pathname)
                          ? "active"
                          : ""
                      }
                      onClick={closeDrawer}
                    >
                      <SavedDesignsIcon />
                      Saved Designs
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to={`${env.dashboardPath}/dsa/manage`}>
                      <DisplayIconBlack/>
                      Display
                    </NavLink>
                  </li>
                  {/*pos.enabled && <li>
                    <NavLink to={`${env.dashboardPath}/design-updater`} onClick={closeDrawer}>
                      {pos.enabled && pos.isToast && <img className="pos-icon" src="https://timber.mhmcdn.com/site/marketing/icons/Toast.svg" alt="Toast small icon"/>}
                      {pos.enabled && pos.isSquare && <img className="pos-icon" src="https://timber.mhmcdn.com/site/marketing/icons/Square.svg" alt="Square small icon"/>}
                      {pos.enabled && !pos.isSquare && !pos.isToast && !pos.isClover && <BarsOutlined />}
                      POS Integration {hasUnsolvedToastChanges && <span className={'exclamation-icon'}><ExclamationCircleFilled /></span>}
                    </NavLink>
                  </li>*/}
                  <li>
                    <Button
                      onClick={onOnlineMenuClick}
                      type={"link"}
                      loading={isOoLoading}
                      className={loc.pathname.indexOf("online-menus") > -1 ? "active" : ""}
                    >
                      {!isOoLoading && <OnlineMenusIcon />}
                      Online Menus
                    </Button>
                  </li>
                  <li>
                    <NavLink
                      to={`${env.dashboardPath}/link-pages/${activeLocation.internalId}`}
                      onClick={closeDrawer}
                    >
                      <LinkPagesIconBlack />
                      Link Pages
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to={`${env.dashboardPath}/brand/${activeLocation.internalId}`}
                      onClick={closeDrawer}
                    >
                      <MyBrandIcon />
                      Brand
                    </NavLink>
                  </li>
                  <div className={"separator"}></div>
                  <li className="wide-svg">
                    <a href={"https://intercom.help/musthavemenus-289b0117ae34/en"} rel="external" onClick={closeDrawer}>
                      <QuestionCircleOutlined />
                      Help Center
                    </a>
                  </li>
                  <li>
                    <NavLink
                      to={env.dashboardPath + "/print/checkout"}
                      onClick={closeDrawer}
                    >
                      <CartIcon />
                      Print Cart&nbsp;{cartCount > 0 && <span className={"cart-count"}>({cartCount})</span>}
                    </NavLink>
                  </li>

                  <div className="btn-container">
                    {/*<div className="btn-container menu-services-ad">
                      <span>50% off Sale!</span>
                      <Button onClick={goToDesignServices} className={"primary ds-btn"}>
                        <img src="https://timber.mhmcdn.com/site/marketing/icons/PaintbrushWhite.svg" alt="white paintbrush" />
                        Menu Services
                      </Button>
                    </div>*/}
                    <Button onClick={goToDesignServices} className={"primary ds-btn"}>
                      <img src="https://timber.mhmcdn.com/site/marketing/icons/PaintbrushWhite.svg" alt="white paintbrush" />
                      Menu Services
                    </Button>
                  </div>
                </ul>}
                {!member.id && <>
                  <ul>
                    <MobileTemplatesDropdown closeDrawer={closeDrawer} />
                    <MobileDigitalDropdown closeDrawer={closeDrawer} />
                    <li className={"large-svg"}>
                      <a href={"/feature/explore.html"} onClick={closeDrawer}>
                        <CompassIcon />
                        Explore
                      </a>
                    </li>
                    <li className={"large-svg"}>
                      <a href={"/menu/pricing.do"} onClick={closeDrawer}>
                        <PricingIcon />
                        Pricing
                      </a>
                    </li>
                    <div className="separator"></div>
                    <li className={"large-svg"}>
                      <a href={"/account/login"} onClick={closeDrawer}>
                        <img className="signout-icon" src="https://timber.mhmcdn.com/site/marketing/icons/User.svg" alt="Sign Out"/>
                        Log In
                      </a>
                    </li>
                  </ul>
                
                  <div className="full-btn demo-btn">
                    <Button onClick={bookDemoClick} className={"primary"}>
                      Book a Demo
                    </Button>
                  </div>
                </>}
              </nav>
            </>
          )}

          {mode === AsideMode.Account && (
            <>
              <nav className={"account-aside"}>
                <ul>
                  <li>
                    <NavLink
                      className={"user-info"}
                      to={env.dashboardPath + "/account/users"}
                      onClick={closeDrawer}
                    >
                      <SettingOutlined />
                      User Info
                    </NavLink>
                  </li>
                  {member.plan !== MemberDtoPlanEnum.Free && member.owner && !member.clover && (
                    <li>
                      <NavLink
                        className={"billing-info"}
                        to={env.dashboardPath + "/account/billing"}
                        onClick={closeDrawer}
                      >
                        <CreditCardOutlined />
                        Billing Info
                      </NavLink>
                    </li>
                  )}
                  {member.owner && (
                    <li>
                      <NavLink
                        className={"subscription"}
                        to={env.dashboardPath + "/account/plan"}
                        onClick={closeDrawer}
                      >
                        <DollarCircleOutlined />
                        Subscription
                      </NavLink>
                    </li>
                  )}
                  {member.owner && !member.clover && (
                    <li>
                      <NavLink
                        className={"locations"}
                        to={env.dashboardPath + "/account/locations"}
                        onClick={closeDrawer}
                      >
                        <ChangeLocationIcon />
                        Locations
                        {member.plan !== MemberDtoPlanEnum.Premium && (
                          <ProStar />
                        )}
                      </NavLink>
                    </li>
                  )}
                  {member.owner && !member.clover && (
                    <li>
                      <NavLink
                        className={"team"}
                        to={env.dashboardPath + "/account/team"}
                        onClick={closeDrawer}
                      >
                        <UserIcon />
                        Team
                        {member.plan !== MemberDtoPlanEnum.Premium && (
                          <ProStar />
                        )}{" "}
                      </NavLink>
                    </li>
                  )}
                  {member.owner && (
                    <li>
                      <NavLink
                        className={"print-history"}
                        to={env.dashboardPath + "/account/print"}
                        onClick={closeDrawer}
                      >
                        <PrinterOutlined />
                        Print History
                      </NavLink>
                    </li>
                  )}
                </ul>
              </nav>
            </>
          )}
        </div>
      )}

      <OmInUseModal
        isVisible={isOoInUse}
        onClose={() => {
          setOoInUse(false);
          setOoLoading(false);
        }}
      />
    </>
  );
}
